<template>
  <div v-if="isLoading || !empty(accountInfo)">
    <edit-profile class="w-100" :profile="accountInfo" :isAdmin="true" @onSuccess="initAccountInfo" />
    <Campuses :campuses="accountLocation" :isAdmin="true" @onSuccess="initLocation" />
    <User :accountUsers="accountUsers" @onSuccess="initAccountUser" />

    <a-card class="style1 w-100" v-if="!empty(accountInfo.signature)">
      <div class="d-flex flex-column align-items-center">
        <img :src="accountInfo.signature" id="signature" class="w-auto" />
        <a-button type="primary" class="mt-5" @click="onSave" icon="download"> Download </a-button>
      </div>
    </a-card>
  </div>
  <div v-else>
    <h2>Account not found</h2>
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminAccount' })"> Go to account list </a-button>
  </div>
</template>
<script>
import AdminService from '@/services/AdminService';
import EditProfile from '@/views/profile/editProfile';
import Campuses from '@/views/campuses';
import User from './user';
import { empty } from '@/utils';
export default {
  components: {
    EditProfile,
    Campuses,
    User,
  },
  data() {
    return {
      isLoading: false,
      accountId: null,
      accountInfo: {},
      accountLocation: [],
      accountUsers: [],
    };
  },
  watch: {
    $route: {
      handler(route) {
        this.accountId = route.params.account_id;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.initAccountInfo();
      await this.initLocation();
      await this.initAccountUser();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    empty,
    async initLocation() {
      this.accountLocation = await AdminService.account.getLocation(this.accountId);
    },
    async initAccountInfo() {
      this.accountInfo = await AdminService.account.get(this.accountId);
    },
    async initAccountUser() {
      this.accountUsers = await AdminService.account.getUser(this.accountId);
    },
    onSave() {
      import('@/utils/fileSaver').then(file => {
        const img = new Image();
        const fileName = this.accountId;
        img.src = this.accountInfo.signature;
        img.onload = function () {
          const canvas = document.createElement('CANVAS');
          const ctx = canvas.getContext('2d');
          canvas.height = this.naturalHeight;
          canvas.width = this.naturalWidth;
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(this, 0, 0);
          file.saveImage(canvas, fileName);
        };
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
